export const ADD_DEPOTS = "ADD_DEPOTS";
export const GET_DEPOTS_LIST = "GET_DEPOTS_LIST";
export const DEPOTS_LIST_RESPONCE = "DEPOTS_LIST_RESPONCE";
export const EDIT_DEPOTS = "EDIT_DEPOTS";
export const EDIT_DEPOTS_STATUS = "EDIT_DEPOTS_STATUS";
export const DELETE_DEPOTS = "DELETE_DEPOTS";




// redux state update 
export const EDIT_DEPOTS_REDUX_STATE = "EDIT_DEPOTS_REDUX_STATE";
export const DELETE_DEPOTS_REDUX_STATE = "DELETE_DEPOTS_REDUX_STATE";
export const EDIT_DEPOTS_STATUS_REDUX_STATE = "EDIT_DEPOTS_STATUS_REDUX_STATE";